import { Button } from "@/components/ui/button";
import { Phone, Mail, Menu, Gift } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const handleFreeDisc = () => {
    navigate("/disque-gratuit");
  };
  const handleNosProduitsClick = () => {
    setIsMenuOpen(false); // Fermer le menu mobile
    const element = document.getElementById('gammes-principales');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  };

  const handleContactClick = () => {
    setIsMenuOpen(false); // Fermer le menu mobile
    const element = document.getElementById('contactez-nous');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  };

  const handleAccueilClick = () => {
    setIsMenuOpen(false); // Fermer le menu mobile
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        {/* Top bar */}
        <div className="flex justify-between items-center py-2 text-sm border-b">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <Phone className="h-4 w-4 text-blue-600" />
              <span>+ 33 06 61 01 84 89</span>
            </div>
            <div className="flex items-center space-x-2">
              <Mail className="h-4 w-4 text-blue-600" />
              <span>contact@outilmatpro.fr</span>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <div className="text-orange-500 font-semibold animate-pulse">
              🎁 CODE: BIENVENUE - Disque Gratuit !
            </div>
            <button onClick={handleFreeDisc} className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-1 rounded-full text-sm font-bold transition-colors">
              <Gift className="h-3 w-3 inline mr-1" />
              GRATUIT
            </button>
          </div>
        </div>

        {/* Main navigation */}
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <img src="./images/Logo web outilmatpro.jpg" alt="OutilMatPro Logo" className="h-20 w-auto mr-6 object-contain logo-crisp" />
            <div>
              
              
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={handleAccueilClick} className="text-gray-700 hover:text-orange-500 font-medium">
              Accueil
            </button>
            <button onClick={handleNosProduitsClick} className="text-gray-700 hover:text-orange-500 font-medium">
              Nos Produits
            </button>
            <button onClick={handleContactClick} className="text-gray-700 hover:text-orange-500 font-medium">
              Contact
            </button>
            <button onClick={handleFreeDisc} className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg font-bold transition-colors flex items-center space-x-2">
              <Gift className="h-4 w-4" />
              <span>Parrainage</span>
            </button>
          </nav>

          {/* Mobile menu button */}
          <button className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <Menu className="h-6 w-6" />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="md:hidden pb-4 border-t">
            <div className="flex flex-col space-y-4 pt-4">
              <button onClick={handleAccueilClick} className="text-gray-700 hover:text-orange-500 font-medium text-left">
                Accueil
              </button>
              <button onClick={handleNosProduitsClick} className="text-gray-700 hover:text-orange-500 font-medium text-left">
                Nos Produits
              </button>
              <button onClick={handleContactClick} className="text-gray-700 hover:text-orange-500 font-medium text-left">
                Contact
              </button>
              <button onClick={handleFreeDisc} className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg font-bold transition-colors text-center flex items-center justify-center space-x-2">
                <Gift className="h-4 w-4" />
                <span>Disque Gratuit</span>
              </button>
            </div>
          </nav>}
      </div>
    </header>;
};